import { render, staticRenderFns } from "./hold.vue?vue&type=template&id=2840d369&scoped=true"
import script from "./hold.vue?vue&type=script&lang=js"
export * from "./hold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840d369",
  null
  
)

export default component.exports